import React from 'react';
import { Tooltip } from 'antd';
import styled from 'styled-components';
import { ellipsis } from 'polished';

const Text = styled.span`
  ${ellipsis()};
`;
const TooltipCell = ({ cellData }) => (
  <Tooltip title={cellData} destroyTooltipOnHide>
    <Text>{cellData}</Text>
  </Tooltip>
);

export default TooltipCell;
